import { CoverageCreditIncentive, CoverageCreditIncentiveType } from "../team";

export function getCoverageCreditAmount(
  coverageCreditIncentive: CoverageCreditIncentive | undefined,
  cartTotal: number,
): number {
  if (
    !coverageCreditIncentive?.enabled ||
    cartTotal < coverageCreditIncentive.minimumQualifyingPurchaseAmount
  ) {
    return 0;
  }

  if (coverageCreditIncentive.type === CoverageCreditIncentiveType.FIXED) {
    return coverageCreditIncentive.fixedAmount;
  }

  if (coverageCreditIncentive.type === CoverageCreditIncentiveType.PERCENTAGE) {
    const percentageCreditAmount =
      cartTotal * (coverageCreditIncentive.percentageSettings.percentage / 100);
    const finalAmount = Math.min(
      percentageCreditAmount,
      coverageCreditIncentive.percentageSettings.storeCreditAmountCap ??
        Infinity,
    );
    return finalAmount;
  }

  return 0;
}
